export default __webpack_public_path__ + "static/Photo-Review-0a9ccb88e3b31b0de0d7044366dfdf5b.jpeg";